var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShangpin = function SvgShangpin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.855 1.871c8.061 0 14.627 6.403 14.89 14.4h7.232a3.7 3.7 0 0 1 3.687 4.008l-2.422 29.065a6.9 6.9 0 0 1-6.876 6.327H16.344a6.9 6.9 0 0 1-6.876-6.327L7.045 20.279a3.7 3.7 0 0 1 3.687-4.007h7.233c.263-7.998 6.828-14.4 14.89-14.4Zm.13 24.513a.14.14 0 0 0-.26 0l-2.221 5.34a1.14 1.14 0 0 1-.961.7l-5.767.462a.14.14 0 0 0-.08.246l4.394 3.763c.324.278.466.714.367 1.13l-1.342 5.627a.14.14 0 0 0 .21.152l4.936-3.016a1.14 1.14 0 0 1 1.188 0l4.937 3.016a.14.14 0 0 0 .209-.152l-1.343-5.627a1.14 1.14 0 0 1 .367-1.13l4.394-3.763a.14.14 0 0 0-.08-.246l-5.766-.463a1.14 1.14 0 0 1-.962-.698l-2.22-5.341Zm-.13-20.312c-5.742 0-10.426 4.522-10.687 10.2h21.374c-.261-5.678-4.946-10.2-10.688-10.2Z",
    fill: "url(#shangpin_svg__a)",
    stroke: "url(#shangpin_svg__b)",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shangpin_svg__a",
    x1: 32.855,
    y1: 2.371,
    x2: 32.855,
    y2: 55.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shangpin_svg__b",
    x1: 32.855,
    y1: 2.371,
    x2: 32.855,
    y2: 55.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};

export default SvgShangpin;